export default __webpack_public_path__ + "static/media/国内海外手配旅行 旅行条件書（RTCC宿泊プラン）.4932676a.pdf";